export default __webpack_public_path__ + "static/media/ai-text-transformation-challenge.bcdb6d65.png";